// Available fields for the Truck Operator Request Payment report config
// (ids must match the rows returned by GET /truckOp/reqPymtRept).
const tpReqPymtReptFieldsArr = [
    { id: "trkOp", label: "Truck Operator", minWidth: 170 },
    { id: "truckOpReqId", label: "Request Id", minWidth: 170 },
    { id: "trkRegNo", label: "Truck Number", minWidth: 150 },
    { id: "type", label: "Truck", minWidth: 150 },
    { id: "createdShipmtCount", label: "Created Shipments", minWidth: 50 },
    { id: "createdShipmts", label: "Shipments", minWidth: 170 },
    { id: "basePrc", label: "Base Price", minWidth: 100 },
    { id: "aHalting", label: "Halting(+)", minWidth: 100 },
    { id: "aUlCooliDrv", label: "UL Coolie Paid by Driver(+)", minWidth: 100 },
    { id: "aLdCooliDrv", label: "Loading Coolie Paid by Driver(+)", minWidth: 100 },
    { id: "aIncidental", label: "Incidental Charges(+)", minWidth: 100 },
    { id: "aOthers", label: "Others(+)", minWidth: 50 },
    { id: "dTds", label: "TDS(-)", minWidth: 100 },
    { id: "dCommission", label: "Commission(-)", minWidth: 100 },
    { id: "dPenalty", label: "Penalty(-)", minWidth: 100 },
    { id: "dClaim", label: "Claim(-)", minWidth: 100 },
    { id: "dLdCooli", label: "Loading Coolie(-)", minWidth: 100 },
    { id: "dUlCooli", label: "Unloading Coolie(-)", minWidth: 100 },
    { id: "dFrtLess", label: "Recd Freight Less(-)", minWidth: 100 },
    { id: "dOthers", label: "Others(-)", minWidth: 100 },
    { id: "finalPricing", label: "Total", minWidth: 100 },
    { id: "pendingAmount", label: "Pending", minWidth: 100 },
];

export default tpReqPymtReptFieldsArr;
